import { render, staticRenderFns } from "./CommissionRule.vue?vue&type=template&id=a59ec230&scoped=true"
import script from "./CommissionRule.vue?vue&type=script&lang=js"
export * from "./CommissionRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59ec230",
  null
  
)

export default component.exports